import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MenuSide } from '../../components/MenuSide';
import { FormControl, TextField } from "@mui/material";
import { urlAdicionarEnderecosNatendidos, tokenUsuario } from "../../utils/constants";
import ButtonCustom from '../../components/ButtonCustom';
import SelectCustom from '../../components/SelectCustom';

export default function AdicionarEnderecosNatendidos() {

    const navigate = useNavigate();
    const [endereco, setEndereco] = useState('');
    const [cep, setCep] = useState('');
    const [tipo, setTipo] = useState('');

    const adicionarInformacoes = async () => {
        try {
            const response = await axios.post(urlAdicionarEnderecosNatendidos, {
                endereco: endereco,
                tipo: tipo,
                cep: cep,
                token: tokenUsuario,
            });
            if (response.data == 1) {
                navigate({
                    pathname: "/enderecos_nao_atendidos",
                });
            }
        } catch (error) {
            return null;
        }
    };

    const consultarEndereco = async () => {
        try {
            const response = await axios.get(
                `https://viacep.com.br/ws/${cep}/json/`,
                {}
            );
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const carregarEndereco = async () => {
        const response = await consultarEndereco();
        if (tipo == '1') {
            setEndereco(response.logradouro);
        } else {
            setEndereco(response.bairro);
        }
    }
    useEffect(() => {
        if (cep.length === 8) {
            carregarEndereco();
        }
    }, [cep, tipo]);

    const tipos = [{
        id: 1,
        nome: 'Rua'
    },
    {
        id: 2,
        nome: 'Bairro'
    }];

    return (
        <>
            <div className='row'>
                <div className='col-sm-2'>
                    <MenuSide />
                </div>
                <div className='col-sm-10'>
                    <br />
                    <div className='card' style={{ marginRight: '1%' }}>
                        <div className='card-header'>
                            <div className='row'>
                                <div className='col-sm-6' style={{ fontWeight: 700, fontSize: '25px', }}>
                                    Adicionar endereço não atendido
                                </div>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <h6>CEP</h6>
                                    <FormControl fullWidth>
                                        <TextField
                                            placeholder='CEP'
                                            onChange={(event) => {
                                                event.preventDefault();
                                                setCep(event.target.value)
                                            }}
                                            value={cep}
                                            type="tel"
                                            InputProps={{
                                                sx: {
                                                    height: "39px",
                                                    borderRadius: '0.5rem',
                                                    width: '100%',
                                                    padding: '10px',
                                                }
                                            }} variant="outlined" />
                                    </FormControl>
                                </div>
                                <div className='col-sm-4'>
                                    <h6>Endereço</h6>
                                    <FormControl fullWidth>
                                        <TextField
                                            placeholder='Endereço'
                                            onChange={(event) => {
                                                event.preventDefault();
                                                setEndereco(event.target.value)
                                            }}
                                            value={endereco}
                                            type="text"
                                            InputProps={{
                                                sx: {
                                                    height: "39px",
                                                    borderRadius: '0.5rem',
                                                    width: '100%',
                                                    padding: '10px',
                                                }
                                            }} variant="outlined" />
                                    </FormControl>
                                </div>

                                <div className='col-sm-3'>
                                    <h6>Tipo</h6>
                                    <SelectCustom
                                        value={tipo}
                                        setValue={(event) => {
                                            event.preventDefault();
                                            setTipo(event.target.value);
                                        }}
                                        itens={tipos}
                                        valueItem={"id"}
                                        nameItem={"nome"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='card-footer'>
                            <div className='row'>
                                <div className='col-sm-3'></div>
                                <div className='col-sm-7'></div>
                                <div className='col-sm-2 text-end'>
                                    <ButtonCustom
                                        onClick={() => {
                                            adicionarInformacoes();
                                        }}
                                        color={"error"}
                                        texto={"Confirmar"}
                                        icon={null}
                                    />
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
